import { useContext, useMemo } from 'react';
import { UserContext } from '@/contexts/UserContext';

/**
 * Resolves the active week-start day for the current user.
 *
 * Rules:
 *   - Onward admins (ONWARD_ADMIN role) always see Monday-anchored periods (1).
 *   - Tenant users follow their organization's `week_starts_on`.
 *   - Users with no organization fall back to Monday (1).
 *
 * Returns 0 (Sunday) or 1 (Monday). date-fns accepts these as the `weekStartsOn` option.
 */
export const useWeekStartsOn = () => {
    const { user, organization } = useContext(UserContext);
    console.log(organization);

    return useMemo(() => {
        if (user?.roles?.['ONWARD_ADMIN']) return 1;
        return organization?.week_starts_on ?? 1;
    }, [user, organization]);
};
